<template>
  <div
    class="tab-pane fade"
    id="legalitas"
    role="tabpanel"
    aria-labelledby="legalitas-tab"
  >
    <div class="card-group">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">NPWP : *Max 500kb,(jpg or png)</h5>
          <div class="text-center py-5">
            <img
              :src="user.legality.npwp.image"
              class="img-responsive"
              onError="this.onerror=null;this.src='https://aosa.org/wp-content/uploads/2019/04/image-placeholder-350x350-300x300.png';"
              width="40%"
            />
          </div>
        </div>
        <label for="logo"></label>
        <input
          type="file"
          class="form-control-file ml-3"
          name="logo"
          id="editNpwp"
        />
        <div class="form-group"></div>
        <div class="text-center">
          <button
            type="button"
            @click="editLegality('legalitas_npwp_mall', 'editNpwp')"
            class="btn btn-info"
          >
            Update
          </button>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <h5 class="card-title">SIUP/NIB: *Max 500kb(jpg or png)</h5>
          <div class="text-center py-5">
            <img
              :src="user.legality.siup.image"
              class="img-responsive"
              width="40%"
              onError="this.onerror=null;this.src='https://aosa.org/wp-content/uploads/2019/04/image-placeholder-350x350-300x300.png';"
            />
          </div>
        </div>

        <input type="file" class="form-control-file ml-3" id="editSiup" />
        <div class="form-group">
          <label for="header"></label>
        </div>
        <div class="text-center">
          <button
            type="button"
            @click="editLegality('legalitas_siup_mall', 'editSiup')"
            class="btn btn-info"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    editLegality: Function,
  },
  computed: {
    ...mapGetters({
      user: "user",
    }),
  },
  methods:{
    imgError(image) {
        image.onerror = "";
        image.src = "https://aosa.org/wp-content/uploads/2019/04/image-placeholder-350x350-300x300.png";
        return true;
    } ,
  }
};
</script>